import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

const classes = {
	sdsTerm: 'js-m-download-list__term--sds',
	sdsTermActive: 'state-m-download-list__term--sds-active',
	sdsDefinition: 'js-m-download-list__definition--sds',
	sdsDefinitionActive: 'state-m-download-list__definition--sds-active',
	languageSelector: 'js-m-download-item__language-selector',
	entries: 'js-m-download-list__entry',
	hideEntries: 'state-m-download-list--hide-entries',
	stateHidden: 'state-m-download-list__entry--hidden',
	loadMoreButton: 'js-m-download-list__load-more-button',
	itemHeading: 'js-m-download-list__heading',
};

@createModule('DownloadList')
/**
 * download-list module implementation.
 *
 * @author Lars-Olof Kreim <lars-olof.kreim@namics.com>
 */
export class DownloadList extends TerrificSpec {
	$ctx: JQuery;
	sdsElements: JQuery[];
	start(resolve: () => void) {
		this.$ctx = $(this._ctx);
		this.initSds();
		this.initLoadMoreEntries();
		this.showTitle();
		this.changeTitle();
		resolve();
	}
	initSds() {
		this.sdsElements = [this.$ctx.find(`.${classes.sdsTerm}`), this.$ctx.find(`.${classes.sdsDefinition}`)];
		if (this.sdsElements[0].length > 0 && this.sdsElements[1].length > 0) {
			const serviceUrl = this.$ctx.data('sds-service');
			if (serviceUrl) {
				$.ajax({
					method: 'get',
					url: serviceUrl,
					success: this.onSdsAjaxSuccess.bind(this),
				});
			}
		}
	}
	onSdsAjaxSuccess(data: any) {
		if (data.error || !Array.isArray(data.sdsDownloads) || data.sdsDownloads.length < 1) {
			return;
		}
		const $selectElement = this.sdsElements[1].find(`.${classes.languageSelector}`);
		$selectElement.empty();
		for (let el of data.sdsDownloads) {
			$selectElement.append(`<option value="${el.link}">${el.language}</option>`);
		}
		$selectElement.trigger('change');
		if (data.sdsDownloads.length === 1) {
			$selectElement.addClass('a-input-select--readonly').prop('disabled', true);
		}
		this.sdsElements[0].addClass(classes.sdsTermActive);
		this.sdsElements[1].addClass(classes.sdsDefinitionActive);
	}
	showTitle() {
		const $headingElement = this.$ctx.find(`.${classes.itemHeading}`);
		$headingElement.each((i,e) => {
			const $headingItem = $(e);
			$headingItem.find("span").first().addClass("active");
		});
	}
	changeTitle() {
		const $languageSelect = this.$ctx.find(`.${classes.languageSelector}`);
		$languageSelect.on("change",function(ev: Event){
			var language = $(ev.currentTarget).find("option:selected").text();
			var activeEle = $(ev.currentTarget).parents("dd").prev("dt").find(".active");
			if(activeEle.length == 0) return;
			var curLanguage = activeEle.attr("class").substring(0,2);
			if (language!==curLanguage) {
				$(ev.currentTarget).parents("dd").prev("dt").find("span").removeClass("active");
				$(ev.currentTarget).parents("dd").prev("dt").find("."+language).addClass("active");
			}
		})
	}
	/**
	 * method handles hide/show of entries
	 *
	 * @returns {void}
	 */
	initLoadMoreEntries() {
		const minOfShowEntries = this.$ctx.data('shown-entries');
		if (minOfShowEntries) {
			const $entries = this.$ctx.find(`.${classes.entries}`);

			if ($entries.length / 2 > minOfShowEntries) {
				this.$ctx.addClass(classes.hideEntries);
				$entries.filter(`:nth-child(n + ${minOfShowEntries * 2 + 1})`).addClass(classes.stateHidden);

				this.$ctx.find(`.${classes.loadMoreButton}`).on('click', (ev: any) => {
					this.$ctx.removeClass(classes.hideEntries);
					$entries.removeClass(classes.stateHidden);
				});
			}
		}
	}

	stop() {}
}
